import { createFileRoute } from "@tanstack/react-router"
import ConnectedAccountsPage from "~/components/SocialAccounts/ConnectedAccountsPage"
import AppLayout from "~/layouts/AppLayout"
import { api } from "~/utils/api"

import type { ReactElement } from "react"

const ConnectedAccounts = () => {
  const ctx = api.useUtils()
  const user = ctx.users.getUserWithTeam.getData()

  if (!user) {
    return <></>
  }

  return <ConnectedAccountsPage user={user} />
}

function SocialAccountsPageWrapper() {
  return (
    <AppLayout>
      <ConnectedAccounts />
    </AppLayout>
  )
}

export const Route = createFileRoute("/social-accounts")({
  component: SocialAccountsPageWrapper,
})
